import request from '@/request'

// 根据用户ID加载聊天列表
export function getChatList(userId) {
  return request({
    url: `/chat/getChatList?userId=${userId}`,
    method: 'get'
  })
}

// 创建聊天室
export function addChatRoom(chatRoomDto) {
  return request({
    url: `/chat/addChatRoom`,
    method: 'post',
    data: chatRoomDto
  })
}

// 根据用户ID, 聊天室ID查询历史聊天记录
export function getHistoryMsg(chatRoomId, userId) {
  return request({
    url: `/chat/getHistoryMsg?chatRoomId=${chatRoomId}&userId=${userId}`,
    method: 'get'
  })
}

// 用户在非聊天界面点击私聊申请, senderId申请人ID, receiverId私聊对象ID
export function toChat(senderId, receiverId) {
  return request({
    url: `/chat/toChat?senderId=${senderId}&receiverId=${receiverId}`,
    method: 'get'
  })
}

// 根据聊天室ID及用户ID清空未读数
export function clearUnread(chatRoomId, userId) {
  return request({
    url: `/chat/clearUnread?chatRoomId=${chatRoomId}&userId=${userId}`,
    method: 'get'
  })
}

// 查询用户在线聊天未读数量总数
export function getUnreadChatCount(userId) {
  return request({
    url: `/chat/getUnreadChatCount?userId=${userId}`,
    method: 'get'
  })
}

// 查询聊天规则
export function getChatRules(code,language) {
  return request({
    url: `/chat/getChatRules?code=${code}&lang=${language}`,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/chat.js